export default __webpack_public_path__ + "static/media/avatar10.24e227ac.svg";